export enum ResourceType {
  WindowsLogin
}
